<div role="status" class="sr-only" aria-live="polite">{{ ariaResultAlert }} results found</div>
<table mat-table [dataSource]="dataSource" matSort appAnnounceSortChange>
	<ng-container matColumnDef="eventDate">
		<th mat-header-cell *matHeaderCellDef>
			<div mat-sort-header sortActionDescription="Sort by date and time">Date and Time</div>
			<input
				(click)="$event.stopPropagation()"
				id="sh-ac-lg-filter-eventDate"
				(keyup)="applyColumnFilter($event.target.value, 'eventDate')"
				aria-label="Filter by date and time"
			/>
		</th>
		<!-- This lead column is a th in order to read this column to the user when they are tabbing through the table -->
		<th mat-cell *matCellDef="let row" class="lead-col mat-mdc-cell">{{ cmnServ.displayEsttoLocale(row?.eventDate) }}</th>
	</ng-container>

	<ng-container matColumnDef="eventDisplayText">
		<th mat-header-cell *matHeaderCellDef>
			<div mat-sort-header sortActionDescription="Sort by event">Event</div>
			<input
				(click)="$event.stopPropagation()"
				id="sh-ac-lg-filter-eventDescription"
				(keyup)="applyColumnFilter($event.target.value, 'eventDescription')"
				aria-label="Filter by event"
			/>
		</th>
		<td mat-cell *matCellDef="let row">{{ row?.eventDescription || 'N/A' }}</td>
	</ng-container>

	<ng-container matColumnDef="userFullName">
		<th mat-header-cell *matHeaderCellDef>
			<div mat-sort-header sortActionDescription="Sort by completed by">Completed By</div>
			<input
				(click)="$event.stopPropagation()"
				id="sh-ac-lg-filter-staffName"
				(keyup)="applyColumnFilter($event.target.value, 'staffName')"
				aria-label="Filter by completed by"
			/>
		</th>
		<td mat-cell *matCellDef="let row">{{ row?.staffName || 'Unknown' }}</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
<div *ngIf="logs && logs?.length === 0" style="background-color: #fff">
	<span class="margin-left-20"> No records found. </span>
</div>
<mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" id="sh-ac-lg-paginator"></mat-paginator>
